import React, { useEffect, useState } from "react"
import L10n from "../../../lib/carrot-l10n"
import { withRouter } from "react-router-dom"
import CarrotClient from "lib/carrot-api/index"
import { HttpStatusCodes } from "utils/HttpStatusCodes"
import Helpers from "../../../utils/Helpers"
import RequestResetPassword from "../../views/login/RequestResetPassword"
import Settings from "../../../utils/CarrotConfig"
import { HttpErrors } from "utils/HttpErrors"
import { useSelector } from "react-redux"
import { loginEmail } from "../../../reducers/loginInfo"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()
const client = new CarrotClient(Settings.CARROT_BACKEND_URL)

const RequestResetPasswordContainer = ({ match }) => {
  const [message, setMessage] = useState("")
  const [header, setHeader] = useState("")
  const email = useSelector(loginEmail)

  useEffect(() => {
    const resetPassword = async () => {
      try {
        await client.forgotPassword(email)
      } catch (error) {
        const message = Helpers.getFromMapOrReportAndDefault(
          {
            [HttpErrors.FORBIDDEN]: l`client.forgotPassword.inactiveUser`,
            [HttpErrors.NOT_FOUND]: l`client.forgotPassword.unknownError`,
            [HttpErrors.INTERNAL_SERVER_ERROR]: l`client.forgotPassword.unknownError`,
            [HttpErrors.UNAUTHORIZED]: l`client.forgotPassword.unknownError`
          },
          error.name,
          HttpStatusCodes.INTERNAL_SERVER_ERROR
        )
        setMessage(message)
        return
      }

      setHeader(l`client.emailSent`)
      setMessage(
        l`We’ve sent password reset instructions to the email addresses associated with your account. 
        If you experience any issues, please contact us at support@get-carrot.com.`
      )
    }

    resetPassword()
  }, [])

  return <RequestResetPassword message={message} header={header} />
}

export default withRouter(RequestResetPasswordContainer)
